import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import classes from './Spinner.module.scss';

/* eslint-disable react/prop-types */
const Spinner = ({ containerClasses, spinnerClasses }) => (
  <div className={clsx(containerClasses, classes.container)}>
    <div className={clsx(spinnerClasses, classes.spinner)} />
  </div>
);

Spinner.propTypes = {
  containerClasses: PropTypes.string,
  spinnerClasses: PropTypes.string,
};

Spinner.defaultProps = {
  containerClasses: undefined,
  spinnerClasses: undefined,
};

export default Spinner;
